import React from 'react';
import {Notification} from '../navigation/page-layout';
import {ModelExplainer} from './model-explainer';
import {BOSCO_EXPLAINER_CONFIG} from './model-explainer-configs';

export function BoscoExplainer(props: {pushNotification: (notification: Notification) => void}) {
    return <ModelExplainer config={BOSCO_EXPLAINER_CONFIG} pushNotification={props.pushNotification} />;
}
